import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { TextField, Autocomplete } from '@mui/material';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
const TimeZonePicker = ({ selectedTimeZone, onTimeZoneChange }) => {
    const timeZones = useMemo(() => moment.tz.names(), []);
    const handleChange = useCallback((timeZone) => {
        onTimeZoneChange(timeZone);
    }, [onTimeZoneChange]);
    return (_jsx(Autocomplete, { size: 'small', value: selectedTimeZone, getOptionLabel: (tz) => `${tz} (UTC${moment.tz(tz).format('Z')})`, onChange: (event, newValue) => {
            handleChange(newValue);
        }, sx: { width: '100%' }, options: timeZones, renderInput: (params) => _jsx(TextField, Object.assign({}, params, { label: 'Select Time Zone', fullWidth: true })) }));
};
TimeZonePicker.propTypes = {
    onTimeZoneChange: PropTypes.func.isRequired,
    selectedTimeZone: PropTypes.string,
};
export default TimeZonePicker;
